import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "./contexts/ThemeContext";
import { Toaster } from "./components/ui/sonner";
import HomePage from "./pages/HomePage";
import DownloadPage from "./pages/DownloadPage";

function App() {
  return (
    <div className="App">
      <ThemeProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/:slug" element={<DownloadPage />} />
          </Routes>
        </BrowserRouter>
        <Toaster richColors position="bottom-right" />
      </ThemeProvider>
    </div>
  );
}

export default App;
